import * as React from "react";
import { IPricing } from "src/services/interfaces/calculator/IPricing";
import { formatCurrency } from "src/util/Masks/formatCurrency";
import { PercentageMask } from "src/util/Masks/PercentageMask";
export const PricingResultBaseData = (props: { pricing: IPricing }) => (
  <>
    <span className="subtitle">Dados Base para Cálculo</span>
    <div className="region-container">
      <div className="row">
        <span className="left description">Principal:</span>
        <span className="right description">{formatCurrency(props.pricing?.principal)}</span>
      </div>
      <div className="row">
        <span className="left description">Juros:</span>
        <span className="right description">{formatCurrency(props.pricing?.interest)}</span>
      </div>
      <div className="row">
        <span className="left description">PSS:</span>
        <span className="right description">{props.pricing.isPss ? "Sim" : "Não"}</span>
      </div>
      {props.pricing.isPss && (
        <>
          <div className="row">
            <span className="left description">{props.pricing.pssAbsolute > 0 ? "PSS Absoluto" : "PSS Percentual"}:</span>
            <span className="right description">{props.pricing.pssAbsolute > 0 ? formatCurrency(props.pricing.pssAbsolute) : PercentageMask(props.pricing.pss, 2, 2)}</span>
          </div>
          <div className="row">
            <span className="left description">PSS Futuro:</span>
            <span className="right description">{formatCurrency(props.pricing.pssAbsoluteFuture)}</span>
          </div>
        </>
      )}

      <div className="row">
        <span className="left description">Percentual do Credor:</span>
        <span className="right description">{PercentageMask(props.pricing?.reducedPercentLender, 2, 2)}</span>
      </div>
      <div className="row">
        <span className="left description">Indexador:</span>
        <span className="right description">{props.pricing?.correctionType.toString()}</span>
      </div>
    </div>
  </>
)


// WEBPACK FOOTER //
// ./src/components/common/pricing-result/PricingResultBaseData.tsx